module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Layout 404 */

(function(fox) {
	fox.registerWidget('Layout_404', {

		configure: function(options) {

			this.registerOptions('', {
				page404Urls: {},
				pageContainer: '#container',
				'page404Urls.logged': '/',
				'page404Urls.unLogged': '/',
				memberDetails:'.current.member'
			})

			this.callParent('configure', arguments);
		},

		init: function() {
			this.handleEvent(this, 'addedToDom', fox.bind(this.attachHandlers, this));
			
			return this.callParent('init', arguments);
		},

		running: function() {
			this.handleEvent(fox.Navigator, 'modified_0', fox.bind(this.getMemberDetails, this));
		},

		logout: function() {
			fox.site.logout();
		},

		attachHandlers: function() {
			fox.dom.on('click', fox.dom.selectFirst('#logout', this.element), fox.bind(this.logout, this));
		},

		getMemberDetails: function() {
			console.log('getMemberDetails');
			var api = this.getApi('Client_Profile_getDetails', {method: 'Client_Profile.getDetails'});
			this.handleEvent(api, 'success', fox.bind(
				function(data) {
					console.log('loaded');
					var response = data.answer.response.success;
					$(this.options.memberDetails).text(response.email);
				}, this));
			api.send();
		}

	}, 'Site_Layout');
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/layout/404.js
// module id = 313
// module chunks = 2